import { db } from '../firebase';
import {
  collection, getDocs, getDoc,
  doc, query, orderBy, serverTimestamp
} from 'firebase/firestore';
import { logService } from './logService';
import { maskIfViewer } from '../utils/permissions';
import { addDoc, updateDoc, deleteDoc } from './guardedDb';

const VEHICLE_COLLECTION = 'E2B_VEHICLES'; 
const MASTER_COLLECTION = 'E2B_VEHICLE_MASTERS'; // [수정완료] 사진에 나온 정확한 이름입니다

export const vehicleService = {
  // 1. 기초 마스터 모델 가져오기 (드롭다운 연동)
  getVehicleModels: async () => {
    try {
      const querySnapshot = await getDocs(collection(db, MASTER_COLLECTION));
      // id:null 데이터가 덮어쓰지 않도록 순서 조정
      return querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
    } catch (e) { return []; }
  },

  // 2. 등록된 차량 목록 가져오기
  getVehicles: async () => {
    try {
      const q = query(collection(db, VEHICLE_COLLECTION), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id, customerName: maskIfViewer(doc.data().customerName), ownerName: maskIfViewer(doc.data().ownerName) }));
    } catch (e) { return []; }
  },

  // 3. 중복 체크 (차량번호 및 차대번호 비교)
  checkDuplicate: (list, formData) => {
    const isCarNumDup = list.some(v => v.carNumber === formData.carNumber && v.id !== formData.id);
    const isVinDup = formData.vin ? list.some(v => v.vin === formData.vin && v.id !== formData.id) : false;
    
    if (isCarNumDup) return `❌ 차량번호 [${formData.carNumber}]가 이미 존재합니다.`;
    if (isVinDup) return `❌ 차대번호 [${formData.vin}]가 이미 존재합니다.`;
    return null;
  },

  // 4. 차량 저장 (수정/등록 통합 및 null ID 저장 방지)
  saveVehicle: async (id, data) => {
    const { id: _, ...pureData } = data; // 저장 시 id 필드를 제외하여 null 값 저장을 방지함
    try {
      if (id) {
        await updateDoc(doc(db, VEHICLE_COLLECTION, id), { ...pureData, updatedAt: serverTimestamp() });
      } else {
        await addDoc(collection(db, VEHICLE_COLLECTION), { ...pureData, createdAt: serverTimestamp() });
      }
      logService.record({
        module: '차량관리', action: id ? 'UPDATE' : 'CREATE',
        target: `차량번호 [${pureData.carNumber || '미지정'}]`,
        details: `${id ? '차량 정보 수정' : '신규 차량 등록'} (차대번호: ${pureData.vin || '-'}, 모델: ${pureData.modelName || '-'})`
      });
    } catch (e) { throw e; }
  },

  // 5. 삭제 기능 (고유 ID 사용)
  deleteVehicle: async (id) => {
    try {
      // 무엇이 지워졌는지 남기기 위해 삭제 전에 차량번호를 확보한다(감사 목적).
      let label = id;
      let vin = '-';
      try {
        const snap = await getDoc(doc(db, VEHICLE_COLLECTION, id));
        if (snap.exists()) { label = snap.data().carNumber || id; vin = snap.data().vin || '-'; }
      } catch (_) { /* 확보 실패해도 삭제는 진행 */ }

      await deleteDoc(doc(db, VEHICLE_COLLECTION, id));
      logService.record({
        module: '차량관리', action: 'DELETE',
        target: `차량번호 [${label}]`,
        details: `차량 정보 삭제 (차대번호: ${vin})`
      });
    } catch (e) { throw e; }
  },

  calculateWarrantyExpiry: (deliveryDate, years) => {
    if (!deliveryDate || deliveryDate.length > 10) return ''; // 날짜 형식이 이상하면 계산 중단
    const date = new Date(deliveryDate);
    if (isNaN(date.getTime())) return '';
    date.setFullYear(date.getFullYear() + parseInt(years));
    return date.toISOString().split('T')[0];
  }
};